import React from 'react'

import clsx from 'clsx'

import { FixedImage } from 'components/NextImage'
import Typography from 'components/Typography'

import classes from './ListingIconName.module.scss'

const noop = () => {}

/** @type {import('./types').default} */
const ListingIconName = ({ className, href, logoUrl, name, onClick = noop }) => {
  return (
    <a className={clsx('ListingIconName', classes.root, className)} href={href} onClick={onClick}>
      <div className={classes.logoContainer}>
        <FixedImage alt={`${name} logo`} className={classes.logo} src={logoUrl} width={40} fetchWidth={60} />
      </div>
      <Typography className={classes.typography} variant="heading-sm">
        {name}
      </Typography>
    </a>
  )
}

export default ListingIconName
